import Layout from '../components/layout/Layout';
import SectionLabel from '../components/shared/SectionLabel';
import SEO from '../components/shared/SEO';
import '../styles/disclaimerpage.css';

export default function VisionMissionPage() {

  return (
    <Layout>
      <SEO
        title="Vision & Mission - Apex DeFi Labs"
        description="Apex DeFi Labs empowers small and medium businesses worldwide by opening up the global capital market to them."
        url="https://apexdefilabs.com/vision-and-mission"
        type="website"
        keywords="Apex DeFi Labs vision, mission, capital market, SMB, democratize capital"
      />

      <div className="disclaimer-page">
        {/* Hero */}
        <section className="disclaimer-hero">
          <div className="disclaimer-hero-overlay" />
          <div className="disclaimer-shell">
            <div style={{ marginBottom: '1.2rem' }}>
              <SectionLabel>About Apex</SectionLabel>
            </div>
            <h1 className="disclaimer-hero-title">
              Vision &amp; <em>Mission</em>
            </h1>
          </div>
        </section>

        {/* Content */}
        <section className="disclaimer-content">
          <div className="disclaimer-shell">
            <article className="disclaimer-section">
              <span className="disclaimer-section-number">01</span>
              <h2 className="disclaimer-section-heading">Our Vision</h2>
              <div className="disclaimer-section-body">
                <p>
                  Apex DeFi Labs empowers small and medium businesses worldwide by opening up the global
                  capital market to them. We provide businesses with access to various capital raise
                  options, levelling the playing field and driving economic growth. Our mission is to
                  democratize access to capital, foster transparency in the crypto assets market, and
                  create a fair ecosystem where businesses and investors can connect with confidence. By
                  promoting responsible investment practices and driving innovation, we aim to build a more
                  inclusive and prosperous world.
                </p>
              </div>
            </article>

            <article className="disclaimer-section">
              <span className="disclaimer-section-number">02</span>
              <h2 className="disclaimer-section-heading">Our Mission</h2>
              <div className="disclaimer-section-body">
                <p>
                  At Apex DeFi Labs, we believe in empowering small and medium businesses globally.
                  Through our platform, businesses gain access to diverse capital raise options, enabling
                  them to compete on a global scale. Our mission is to democratize capital, enhance
                  transparency in the crypto assets market, and establish a fair ecosystem for confident
                  business-investor connections. With a commitment to responsible investing and a focus on
                  innovation, we strive to create a more inclusive and prosperous world for all.
                </p>
              </div>
            </article>
          </div>
        </section>
      </div>
      {/* <BrandsSection brands={brands} isLoading={brandsLoading} /> */}
    </Layout>
  );
}
